import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@pcmp/react-providers';
import {
  useActiveLocationPermissions,
  useShoppingBag,
} from '@/redux/features/shopping-bag/hooks';
import { useUser } from '@/redux/features/session/hooks';
import OrderOnBehalfSider from '@/components/siders/order-on-behalf';
import Button from '@ingka/button';
import styles from './index.module.css';
import ChevronRightSmall from '@ingka/ssr-icon/paths/chevron-right-small';
import { UserPicture } from '@/components/helpers/user-picture';

export const OrderOnBehalfButton: FC = () => {
  // Hooks
  const { t } = useTranslation();
  const { openModal } = useModal();
  const shoppingBag = useShoppingBag();
  const user = useUser();
  const { canOrderOnBehalf } = useActiveLocationPermissions();

  if (!canOrderOnBehalf) return null;

  return (
    <div className="flex items-center justify-center">
      <UserPicture
        email={shoppingBag?.onBehalfOf?.email || user.email || ''}
        displayName={shoppingBag?.onBehalfOf?.displayName || t('label.myself')}
      />

      <span className={`ml-2 ${styles['avatar__description']}`}>
        <b>
          {t('label.product.orderingFor')}{' '}
          {shoppingBag?.onBehalfOf?.displayName ||
            t('label.product.myself') ||
            user.email}
        </b>
      </span>

      <Button
        className="ml-2"
        ssrIcon={ChevronRightSmall}
        iconOnly
        size="xsmall"
        type="tertiary"
        onClick={() =>
          openModal({
            component: OrderOnBehalfSider,
            props: {},
          })
        }
      />
    </div>
  );
};
